export const referralByPatientIdTable = 'SearchReferralsByPatient';
export const treatmentsByReferralIdTable = 'GetTreatmentsByReferralId';
export const patientsTable = 'GetPatients';
export const synchronizationLogTable = 'GetSynchronizationLog';
export const patientHistoricVisitsTable = {
  unallocated: 'GetPatientHistoryUnallocatedVisits',
  allocated: 'GetPatientHistoryAllocatedVisits',
  cancelled: 'GetPatientHistoryCanceledVisits',
  completed: 'GetPatientHistoryCompletedVisits',
};
export const getExcludedCliniciansForPatient = 'GetExcludedCliniciansForPatient';
